import { Box, DropdownButton } from '@dixa/lib-shared-habla';
import { FullPresenceT } from 'lib-shared-legacy-types';

import { PresenceControls } from 'components/presence/components/presenceControls';

import styles from './presencePopover.module.scss';

export const PresencePopover = ({
  fullPresence,
}: {
  fullPresence: FullPresenceT;
}) => (
  <DropdownButton
    data-dropdown-button={true}
    dropdown={
      <Box className={styles.contentContainer}>
        <PresenceControls
          user={fullPresence.user}
          presence={fullPresence.presence}
        />
      </Box>
    }
    buttonProps={{ variant: 'tertiary' }}
    icon="circle-dashed"
  />
);
